
document.addEventListener('DOMContentLoaded', function(){
  const observer = new IntersectionObserver((entries)=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  },{threshold:.12});
  document.querySelectorAll('.ecomx-reveal').forEach(el=>observer.observe(el));
});

document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-ecomx-carousel]').forEach(function(carousel){
    const track=carousel.querySelector('[data-ecomx-track]');
    const prev=carousel.querySelector('.ecomx-carousel-prev');
    const next=carousel.querySelector('.ecomx-carousel-next');
    if(!track)return;
    function step(){
      const s=track.querySelector('.ecomx-carousel-slide');
      if(!s)return Math.min(window.innerWidth*.8,420);
      return s.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||16);
    }
    if(prev)prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
    if(next)next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
  });
});


document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-ecomx-arc-carousel]').forEach(function(carousel){
    const stage = carousel.querySelector('[data-ecomx-arc-stage]');
    const slides = Array.from(carousel.querySelectorAll('.ecomx-arc-slide'));
    const prev = carousel.querySelector('.ecomx-carousel-prev');
    const next = carousel.querySelector('.ecomx-carousel-next');
    if (!stage || !slides.length) return;

    let active = slides.length >= 3 ? 2 : 0;
    if (slides.length === 1) active = 0;
    if (slides.length === 2) active = 0;

    function clearClasses(slide){
      slide.classList.remove('is-far-left','is-left','is-center','is-right','is-far-right','is-hidden');
    }

    function render(){
      slides.forEach(function(slide, i){
        clearClasses(slide);
        let diff = i - active;
        if (diff < -2 || diff > 2) {
          slide.classList.add('is-hidden');
        } else if (diff === -2) {
          slide.classList.add('is-far-left');
        } else if (diff === -1) {
          slide.classList.add('is-left');
        } else if (diff === 0) {
          slide.classList.add('is-center');
        } else if (diff === 1) {
          slide.classList.add('is-right');
        } else if (diff === 2) {
          slide.classList.add('is-far-right');
        }
      });
    }

    function go(dir){
      active += dir;
      if (active < 0) active = slides.length - 1;
      if (active >= slides.length) active = 0;
      render();
    }

    if (prev) prev.addEventListener('click', function(){ go(-1); });
    if (next) next.addEventListener('click', function(){ go(1); });

    let startX = 0;
    let deltaX = 0;
    stage.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; deltaX = 0; }, {passive:true});
    stage.addEventListener('touchmove', function(e){ deltaX = e.touches[0].clientX - startX; }, {passive:true});
    stage.addEventListener('touchend', function(){
      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0) go(1); else go(-1);
      }
    });

    render();
  });
});
